module.exports = __webpack_public_path__ + "img/appdownload-main2@2x.22265004.png";